import { Component, OnInit } from '@angular/core';

import notify from 'devextreme/ui/notify';
import * as XLSX from 'xlsx';
import { FingerDevicesService } from '../../finger-devices.service';

@Component({
  selector: 'app-attending-leaving-from-excel',
  templateUrl: './attending-leaving-from-excel.component.html',
  styleUrls: ['./attending-leaving-from-excel.component.scss']
})
export class AttendingLeavingFromExcelComponent implements OnInit {

  isUploadingBulk: boolean = false;
  bulkResults: any = null;

  constructor(private _FingerDevicesService: FingerDevicesService) {}

  ngOnInit(): void {}

  // ========== File Upload ==========
  triggerUpload(input: HTMLInputElement) {
    input.click();
  }

  onFileUploaded(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rawData: any[] = XLSX.utils.sheet_to_json(worksheet);

      if (rawData.length === 0) {
        notify('الملف فارغ!', 'warning', 3000);
        return;
      }

  const items = rawData.map((row: any) => ({
  employeeCode: String(row['EmployeeCode'] || row['كود الموظف'] || '').trim(), // ✅
  employeeName: row['اسم الموظف'] || row['EmployeeName'] || '',
  dateOfDay: this.formatExcelDate(row['التاريخ'] || row['Date']),
  timeAttending: this.parseTime(row['وقت الحضور'] || row['TimeAttending']),
  timeLeave: this.parseTime(row['وقت الانصراف'] || row['TimeLeave'])
}));

      this.uploadBulk(items);
    };

    reader.readAsArrayBuffer(file);
    event.target.value = '';
  }

  uploadBulk(items: any[]) {
    this.isUploadingBulk = true;
    this.bulkResults = null;

    this._FingerDevicesService.AddBulk({ items }).subscribe({
      next: (res: any) => {
        this.bulkResults = res;
        this.isUploadingBulk = false;

        if (res.failedCount === 0) {
          notify('تم رفع جميع السجلات بنجاح', 'success', 3000);
        } else {
          notify(`تم رفع ${res.successCount} سجل، فشل ${res.failedCount} سجل`, 'warning', 5000);
        }
      },
      error: (err:any) => {
        this.isUploadingBulk = false;
        notify('حدث خطأ أثناء الرفع الجماعي', 'error', 3000);
        console.error(err);
      }
    });
  }

  // ========== Export Failed ==========
  exportFailedRows() {
    if (!this.bulkResults?.errors?.length) {
      notify('لا توجد أخطاء للتصدير', 'info', 2000);
      return;
    }

    const failedData = this.bulkResults.errors.map((error: any) => ({
      'السطر': error.rowIndex,
      'اسم الموظف': error.employeeName || '',
      'التاريخ': error.dateOfDay ? new Date(error.dateOfDay).toLocaleDateString('ar-EG') : '',
      'الأخطاء': error.errors.join(', ')
    }));

    const ws = XLSX.utils.json_to_sheet(failedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'الأخطاء');
    ws['!cols'] = [{ wch: 10 }, { wch: 25 }, { wch: 15 }, { wch: 60 }];
    XLSX.writeFile(wb, 'حضور_فاشل_لإعادة_التعديل.xlsx');
    notify('تم تصدير الأخطاء بنجاح', 'success', 2000);
  }

  // ========== Download Template ==========
 downloadTemplate() {
  const template = [
    {
      'EmployeeCode': '352',          // ✅
      'اسم الموظف': 'أحمد محمد',
      'التاريخ': '15/01/2024',
      'وقت الحضور': '08:00',
      'وقت الانصراف': '17:00'
    },
    {
      'EmployeeCode': '101',          // ✅
      'اسم الموظف': 'محمد علي',
      'التاريخ': '15/01/2024',
      'وقت الحضور': '08:30',
      'وقت الانصراف': '16:45'
    }
  ];

  const ws = XLSX.utils.json_to_sheet(template);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'قالب الحضور والانصراف');
  ws['!cols'] = [
    { wch: 15 },  // EmployeeCode  ✅
    { wch: 20 },  // اسم الموظف
    { wch: 15 },  // التاريخ
    { wch: 15 },  // وقت الحضور
    { wch: 15 }   // وقت الانصراف
  ];
  XLSX.writeFile(wb, 'قالب_الحضور_والانصراف.xlsx');
  notify('تم تحميل القالب بنجاح', 'success', 2000);
}

  // ========== Helpers ==========
  formatExcelDate(excelDate: any): string {
    if (!excelDate) return new Date().toISOString();
    if (typeof excelDate === 'number') {
      return new Date((excelDate - 25569) * 86400 * 1000).toISOString();
    }
    if (typeof excelDate === 'string') {
      const parts = excelDate.split('/');
      if (parts.length === 3) {
        return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).toISOString();
      }
    }
    return new Date(excelDate).toISOString();
  }

  parseTime(timeValue: any): string | null {
    if (!timeValue) return null;
    if (typeof timeValue === 'number') {
      const totalSeconds = Math.round(timeValue * 24 * 60 * 60);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    if (typeof timeValue === 'string') {
      const parts = timeValue.split(':');
      if (parts.length === 2) return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:00`;
      if (parts.length === 3) return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:${parts[2].padStart(2, '0')}`;
    }
    return timeValue.toString();
  }
}